import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Coloured screen flashes on big moves and crits (and the frost creeping in round the screen). */
    flash: boolean;
  }
}

defineSetting({
  key: 'flash',
  default: true,
  order: 50,
  menu: { group: 'visual', label: 'จอวาบเมื่อใช้ท่าใหญ่' },
});
